define('plugin/any-provider/model/AnyProviderModel',['require','model/ProviderModel'],function (require) {

    var ProviderModel = require('model/ProviderModel');

    /**
     * Provider info model
     *
     * @class ProviderModel
     */
    return ProviderModel.extend({

        url: '/ext/any-unit/',

        defaults: _.extend(ProviderModel.prototype.defaults, {
            'id': null,
            'hide_other_providers': true
        })

    });

});
